import React, { useEffect, useState } from "react";
import { readQueue, flushQueue } from "../lib/offline";
import { WifiHigh, WifiSlash, CloudArrowUp, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ConnectionStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(readQueue().length);

  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    const onQueue = (e) => setPending(e.detail?.size ?? readQueue().length);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    window.addEventListener("irs:queue", onQueue);
    const t = setInterval(() => setPending(readQueue().length), 5000);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
      window.removeEventListener("irs:queue", onQueue);
      clearInterval(t);
    };
  }, []);

  const forceFlush = async () => {
    const r = await flushQueue();
    setPending(readQueue().length);
    if (r.synced) toast.success(`Synced ${r.synced} queued ${r.synced === 1 ? "count" : "counts"}`);
    if (r.failed) toast.error(`${r.failed} queued counts were rejected by the server`);
    if (!r.synced && !r.failed && r.remaining) toast.message("Still offline — will retry automatically");
  };

  if (online && pending === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] text-emerald-700" title="Connected" data-testid="conn-online">
        <WifiHigh className="w-4 h-4" /> Online
      </span>
    );
  }
  if (!online) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] text-rose-700 font-medium" title="Offline mode — changes are queued locally" data-testid="conn-offline">
        <WifiSlash className="w-4 h-4" /> Offline{pending > 0 ? ` · ${pending} queued` : ""}
      </span>
    );
  }
  // Online but queue has items
  return (
    <button onClick={forceFlush} className="inline-flex items-center gap-1 text-[11px] text-amber-800 hover:text-amber-900 font-medium" title="Queued counts waiting to sync — click to retry" data-testid="conn-pending">
      <CloudArrowUp className="w-4 h-4" /> Syncing · {pending} pending
    </button>
  );
}
